import React, { Component } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = { value: props.value || props.defaultValue }
    this.onChange = this.onChange.bind(this)
    this.onFocus = this.onFocus.bind(this)
  }

  componentDidMount() {
    this.props.onValueChange(this.value)
  }

  componentWillReceiveProps(props) {
    if (props.value === undefined) { return; }
    this.setState({ value: props.value });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.options.length !== this.props.options.length) {
      this.props.onValueChange(this.value);
      this.props.onOptionsLoad();
    }
  }

  // TODO: rename to placeholder
  blankOption() {
    return { text: this.props.includeBlank, value: '' };
  }

  get otherOption() {
    return { text: 'Other', value: 'other' };
  }

  get value() {
    return this.refs.select.value;
  }

  onChange(e) {
    this.setState({ value: e.target.value })
    this.props.onChange(e)
    this.props.onValueChange(this.value)
  }

  onFocus = (e) => {
    this.props.onFocus(e)
  };

  onBlur = (e) => {
    e.target.blur();
  };

  selectClassNames() {
    return classNames('ds-input',
      { '_error': this.props.error },
      this.props.className,
    )
  }

  getOptions() {
    const additionalOptions = [];

    if (this.props.includeBlank) additionalOptions.push(this.blankOption());
    if (this.props.includeOther) additionalOptions.push(this.otherOption);

    return additionalOptions.concat(this.props.options);
  }

  renderLabel() {
    if (this.props.label) return <span> {this.props.label} </span>;
  }

  renderError() {
    if (this.props.error) return <i> {this.props.error} </i>;
  }

  renderTooltip() {
    if (this.props.tooltip) return <small> {this.props.tooltip} </small>;
  }

  render() {
    const {
      renderOptions,
      onOptionsLoad,
      onValueChange,
      ...restOfProps
    } = this.props;

    return (
      <label className={this.selectClassNames()}>
        {this.renderLabel()}
        {this.renderError()}
        <div className="ds-select">
          <select
            {...restOfProps}
            ref="select"
            value={this.state.value}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            data-test={`${restOfProps.name}-select`}
          >
            {this.props.renderOptions(this.getOptions())}
          </select>
          <div className="select__arrow"></div>
        </div>
        {this.renderTooltip()}
      </label>
    );
  }
}

Select.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func
}

Select.defaultProps = {
  options: [],
  onOptionsLoad() {},
  onChange() {},
  onFocus() {},
  onValueChange(value) {},
  renderOptions(options) {
    return options.map((option, i) => {
      return <option key={i} data-testid={option.value} value={option.value}>{option.text}</option>;
    });
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/Select.js